import React from 'react';
import SentimentVeryDissatisfiedOutlinedIcon from '@material-ui/icons/SentimentVeryDissatisfiedOutlined';

const styles = {
  screenContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '200px 0',
  },
};

const NotFound = () => (
  <div style={styles.screenContainer}>
    <SentimentVeryDissatisfiedOutlinedIcon fontSize="large" />
    <h2>Page Not Found</h2>
  </div>
);

export default NotFound;
